import { I_Down, I_Edit, I_Pin, I_Plus, I_Pulse, I_Refresh, I_Send, I_Spark } from "./icons";
import { fmtDateTime, timeAgo } from "../lib/format.js";

const ActivityList = ({ items, clients, properties, onOpenClient, onOpenProperty, compact }) => (
    <div className="relative">
      <div className="absolute left-[14px] top-2 bottom-2 w-px bg-gradient-to-b from-amber-300/30 via-white/[0.06] to-transparent" />
      <div className="space-y-2.5">
        {items.map((a, i) => {
          const c = a.entity_type === "client" ? clients.find((x) => x.id === a.entity_id) : null;
          const p =
            a.entity_type === "property" ? properties.find((x) => x.id === a.entity_id) : null;
          const ICN =
            {
              created: I_Plus,
              updated: I_Edit,
              status: I_Refresh,
              visit: I_Pin,
              followup: I_Send,
              matched: I_Spark,
              imported: I_Down,
            }[a.kind] || I_Pulse;
          const tone =
            {
              created: "text-emerald-300 bg-emerald-400/10",
              updated: "text-sky-300 bg-sky-400/10",
              status: "text-violet-300 bg-violet-400/10",
              visit: "text-amber-300 bg-amber-400/10",
              followup: "text-teal-300 bg-teal-400/10",
              matched: "text-amber-200 bg-amber-300/10",
              imported: "text-slate-300 bg-white/[0.06]",
            }[a.kind] || "text-slate-300 bg-white/[0.06]";
          return (
            <div key={a.id || i} className="relative flex items-start gap-3 pl-1">
              <div
                className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ring-2 ring-slate-950 z-10 ${tone}`}
              >
                <ICN size={12} />
              </div>
              <div className="min-w-0 flex-1 pt-1">
                <div className="text-sm text-slate-200">
                  {a.summary || "Activity"}
                  {c && (
                    <button
                      onClick={() => onOpenClient(c.id)}
                      className="ml-1 text-amber-200 hover:underline"
                    >
                      {c.name}
                    </button>
                  )}
                  {p && (
                    <button
                      onClick={() => onOpenProperty(p.id)}
                      className="ml-1 text-teal-200 hover:underline"
                    >
                      {p.title}
                    </button>
                  )}
                </div>
                <div
                  className="text-[11px] text-slate-500 mt-0.5"
                  title={fmtDateTime(a.created_at)}
                >
                  {timeAgo(a.created_at)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

export { ActivityList };
